"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./ProgressBar.css");

var _styles = {
  "progress-bar": "ProgressBar__progress-bar___LAxnh",
  "small": "ProgressBar__small___28ns-",
  "large": "ProgressBar__large___1CNeu",
  "growth-bar": "ProgressBar__growth-bar___2csuj",
  "dark": "ProgressBar__dark___3yJ_O",
  "line": "ProgressBar__line___3Rk7k",
  "line-lime": "ProgressBar__line-lime___3pePM"
};

const styles = _bind.default.bind(_styles);

const ProgressBar = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  progress,
  variant = `primary`,
  size = `medium`,
  growthDurationMS,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('progress-bar', size, variant), className);
  return _react.default.createElement("div", {
    className: composed_classname,
    "data-testid": dataTestId,
    ...props
  }, _react.default.createElement("div", {
    "data-testid": dataTestId && `${dataTestId}-growth-bar`,
    className: styles('growth-bar'),
    style: {
      width: `${Math.min(progress, 1) * 100}%`,
      transitionDuration: growthDurationMS ? `${growthDurationMS}ms` : undefined
    }
  }));
});
var _default = ProgressBar;
exports.default = _default;